import { AllRfqThemeSizeConfig } from './types';

const small: AllRfqThemeSizeConfig = {
  allRfq: {},
};

export default small;
